import React from 'react';
import { CheckIcon, GiftIcon, LockIcon, ShieldCheckIcon } from 'lucide-react';
import { CDV_ANNUAL_URL, CDV_MONTHLY_URL, bonuses, includes, joinSteps, premiumBonus } from '../../data/academiaCdv';
import { trackPage } from '../../utils/analytics';
export function OfferAndPricing() {
  return <>
      {/* OFERTA */}
      <section aria-labelledby="oferta-heading" className="w-full bg-[#0B0B0B] border-y border-white/10 px-5 py-16 md:py-24" data-id="element-111" data-mp="11zpsfaxrx0ob">
        <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-5 gap-12" data-id="element-112" data-mp="1unlocdfiqok1">
          <div className="lg:col-span-3" data-id="element-113" data-mp="1fyyz9k03aifm">
            <h2 id="oferta-heading" className="font-sans text-2xl md:text-4xl font-bold uppercase leading-tight mb-8" data-id="element-114" data-mp="1fxxozhqwdzyy">
              Lo que obtienes al unirte hoy
            </h2>
            <ul className="divide-y divide-white/10 border-y border-white/10" data-id="element-115" data-mp="28m1r5ta9fuww">
              {includes.map(item => <li key={item.name} className="flex gap-4 py-5" data-id="element-116" data-mp="2dg62spuh0r4b">
                  <CheckIcon className="mt-1 h-5 w-5 flex-shrink-0 text-gold-metallic" aria-hidden="true" data-id="element-117" data-mp="uerqucy42kzq" />
                  <div data-id="element-118" data-mp="136tsufntw9c4">
                    <p className="font-semibold text-white" data-id="element-119" data-mp="1373jm5gp6kiv">{item.name}</p>
                    <p className="mt-1 text-sm text-white/60 leading-relaxed" data-id="element-120" data-mp="yf1ydu1jxjgp">
                      {item.description}
                    </p>
                  </div>
                </li>)}
            </ul>
          </div>

          <aside className="lg:col-span-2 flex flex-col gap-6" data-id="element-121" data-mp="184v9ktxs7wkf">
            <div className="rounded-2xl border border-gold-metallic/40 bg-[#1C1710] p-6 md:p-7" data-id="element-122" data-mp="1m5o3pdk68pn0">
              <div className="flex items-center gap-3" data-id="element-123" data-mp="1i317l0ggwik0">
                <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-gold-metallic text-black" data-id="element-124" data-mp="1i1gdfby2f1mo">
                  <GiftIcon className="h-5 w-5" aria-hidden="true" data-id="element-125" data-mp="3jvfqa1qu5r1h" />
                </span>
                <h3 className="font-sans text-xl md:text-2xl font-extrabold uppercase leading-tight text-white" data-id="element-126" data-mp="1mujkzbm9pxts">
                  Bonos de regalo
                </h3>
              </div>
              <ul className="mt-5 space-y-3.5" data-id="element-127" data-mp="1wsh9m081hwmx">
                {bonuses.map(bonus => <li key={bonus} className="flex gap-3 text-white leading-snug" data-id="element-128" data-mp="1wutyyyg4n9a0">
                    <CheckIcon className="mt-0.5 h-5 w-5 flex-shrink-0 text-gold-metallic" aria-hidden="true" data-id="element-129" data-mp="25txho1bdtmnz" />
                    {bonus}
                  </li>)}
              </ul>
            </div>
            <div className="rounded-2xl bg-gold-metallic p-6 md:p-7 text-black shadow-[0_12px_32px_rgba(212,175,55,0.25)]" data-id="element-130" data-mp="2khsb5jx7rv24">
              <p className="inline-flex items-center gap-1.5 rounded-full bg-black px-3 py-1 text-xs font-bold uppercase tracking-wider text-gold-metallic" data-id="element-131" data-mp="2pi6a8cgu7uo0">
                <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-132" data-mp="hven58ia0kmg" />
                Bono exclusivo Plan Premium
              </p>
              <p className="mt-4 font-sans text-xl md:text-2xl font-extrabold uppercase leading-tight" data-id="element-133" data-mp="dtjm8549c997">
                {premiumBonus}
              </p>
              <p className="mt-2 text-sm font-semibold text-black/75" data-id="element-134" data-mp="8wji3zqyxgkq">
                Solo al elegir el plan anual de $247.
              </p>
            </div>
          </aside>
        </div>
      </section>

      {/* PRECIO */}
      <section id="precio" aria-labelledby="precio-heading" className="w-full px-5 py-16 md:py-24" data-id="element-135" data-mp="wkj46mdc4isz">
        <div className="max-w-5xl mx-auto" data-id="element-136" data-mp="rs9m1sigon19">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-137" data-mp="rr7yiok9e82n">
            <p className="text-sm font-bold uppercase tracking-wider text-[#FF4D5E]" data-id="element-138" data-mp="mtybffkce8hz">
              Oferta por tiempo limitado · Cierra el Lunes 12 de Octubre, 11:59
              PM (CDMX)
            </p>
            <h2 id="precio-heading" className="mt-3 font-sans text-2xl md:text-4xl font-bold uppercase leading-tight" data-id="element-139" data-mp="1fhu5sdmfvobl">
              Bloquea tu precio ahora
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-5 gap-6 items-stretch" data-id="element-140" data-mp="144ac8az9hrms">
            <div className="order-2 md:order-1 md:col-span-2 flex flex-col rounded-2xl border border-white/15 bg-white/[0.02] p-6 md:p-8" data-id="element-141" data-mp="q3zlr91v6f25">
              <p className="text-sm font-bold uppercase tracking-wider text-white/70" data-id="element-142" data-mp="v456045t0za7">
                Plan Mensual
              </p>
              <p className="mt-3 flex items-baseline gap-2" data-id="element-143" data-mp="1nqgd7xnx1yfz">
                <span className="font-sans text-5xl font-extrabold text-white" data-id="element-144" data-mp="1nssue8luo4rz">
                  $47
                </span>
                <span className="text-lg text-white/60" data-id="element-145" data-mp="1e0wt6oogvyjj">USD / mes</span>
              </p>
              <p className="mt-2 text-white/70" data-id="element-146" data-mp="1dyk7q1ji361q">
                Conservas este precio mientras sigas dentro. Cancela cuando
                quieras.
              </p>
              <div className="mt-auto pt-8" data-id="element-147" data-mp="26isesi6qwvp2">
                <a href={CDV_MONTHLY_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackPage('cdv_mensual_click')} className="flex w-full items-center justify-center rounded-xl border-2 border-white/30 px-6 py-4 text-center text-sm md:text-base font-bold uppercase text-white transition-colors duration-150 ease-out hover:border-white hover:bg-white hover:text-black focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-148" data-mp="3r7d1rhbyo1re">
                  Quiero el Plan Mensual
                </a>
              </div>
            </div>

            <div className="order-1 md:order-2 md:col-span-3 relative flex flex-col rounded-2xl border-2 border-gold-metallic bg-[#1C1710] p-6 md:p-8 shadow-[0_12px_40px_rgba(212,175,55,0.18)]" data-id="element-149" data-mp="3haqgirfq38ou">
              <span className="absolute -top-3.5 left-6 rounded-full bg-gold-metallic px-3 py-1 text-xs font-extrabold uppercase tracking-wider text-black" data-id="element-150" data-mp="whmzp7a9pfp8">
                Mejor valor · Ahorras más del 50%
              </span>
              <p className="text-sm font-bold uppercase tracking-wider text-gold-metallic" data-id="element-151" data-mp="3lefninah91kj">
                Plan Premium Anual
              </p>
              <p className="mt-3 flex flex-wrap items-baseline gap-x-3 gap-y-1" data-id="element-152" data-mp="3uduednuk3e5k">
                <span className="font-sans text-6xl md:text-7xl font-extrabold text-white" data-id="element-153" data-mp="36zzon6xib60">
                  $247
                </span>
                <span className="text-lg text-white/70" data-id="element-154" data-mp="32n6h4mw06sx6">USD / año</span>
                <span className="text-base text-white/45 line-through" data-id="element-155" data-mp="36mfb9suygst9">
                  $797
                </span>
              </p>
              <ul className="mt-4 space-y-2 text-white/85" data-id="element-156" data-mp="3bkyuvmm2tsig">
                <li className="flex gap-2.5" data-id="element-157" data-mp="3gd9ueocwncah">
                  <CheckIcon className="mt-0.5 h-5 w-5 flex-shrink-0 text-gold-metallic" aria-hidden="true" data-id="element-158" data-mp="3gf330972w6l4" />
                  Todo desbloqueado desde el primer día
                </li>
                <li className="flex gap-2.5" data-id="element-159" data-mp="2gdptyr8fpzdr">
                  <CheckIcon className="mt-0.5 h-5 w-5 flex-shrink-0 text-gold-metallic" aria-hidden="true" data-id="element-160" data-mp="2gcercuqq6xo8" />
                  <span data-id="element-161" data-mp="26dz2kyf680hw">
                    Incluye la{' '}
                    <strong className="text-white" data-id="element-162" data-mp="22df1xkve2er0">
                      Consultoría 1 a 1 de IA
                    </strong>
                  </span>
                </li>
              </ul>
              <div className="mt-auto pt-8" data-id="element-163" data-mp="1xg53xgtxourk">
                <a href={CDV_ANNUAL_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackPage('cdv_anual_click')} className="flex w-full items-center justify-center rounded-xl bg-gold-metallic px-6 py-4 md:py-5 text-center text-base md:text-lg font-extrabold uppercase text-black shadow-lg transition-[background-color,transform] duration-150 ease-out hover:bg-[#E5C04B] active:scale-[0.99] focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black" data-id="element-164" data-mp="1smkgujtvpl75">
                  Quiero el Plan Anual con descuento
                </a>
              </div>
            </div>
          </div>

          {/* Price-lock transparency */}
          <div className="mt-12 max-w-3xl mx-auto flex gap-4 rounded-2xl border border-white/10 p-6" data-id="element-165" data-mp="2sl1gc8allz3w">
            <LockIcon className="mt-1 h-5 w-5 flex-shrink-0 text-gold-metallic" aria-hidden="true" data-id="element-166" data-mp="2eu66ots9zdz9" />
            <p className="text-white/70 leading-relaxed" data-id="element-167" data-mp="2jnhb6o9m7io0">
              Quiero ser completamente transparente contigo: conforme aumenta el
              contenido, las mentorías y el valor de la comunidad, el precio
              también irá aumentando.{' '}
              <strong className="text-white" data-id="element-168" data-mp="1vxerowjrnl10">
                Si entras hoy, nunca volverás a pagar un precio mayor que el que
                bloquees hoy.
              </strong>
            </p>
          </div>

          {/* Join in 3 steps */}
          <div className="mt-16" data-id="element-169" data-mp="1caa5hcjcenzz">
            <h3 className="text-center font-sans text-xl md:text-2xl font-bold uppercase mb-8" data-id="element-170" data-mp="1cbbs8e9q0yxj">
              Únete hoy en 3 pasos
            </h3>
            <ol className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-171" data-mp="1q7qb4lttedqo">
              {joinSteps.map((step, i) => <li key={step.title} className="flex gap-4" data-id="element-172" data-mp="20891lzfvwshk" data-mpi={i}>
                  <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-gold-metallic font-bold text-black" data-id="element-173" data-mp="206o5i5dx91hl">
                    {i + 1}
                  </span>
                  <div data-id="element-174" data-mp="29xixlqdumvay">
                    <p className="font-semibold text-white" data-id="element-175" data-mp="29zvc1tkeenj9">{step.title}</p>
                    <p className="mt-1 text-sm text-white/60 leading-relaxed" data-id="element-176" data-mp="24zr4wu5dr55p">
                      {step.description}
                    </p>
                  </div>
                </li>)}
            </ol>
          </div>

          <p className="mt-12 flex items-center justify-center gap-2 text-center text-sm text-white/60" data-id="element-177" data-mp="19jsud8ip68f">
            <ShieldCheckIcon className="h-4 w-4 flex-shrink-0 text-gold-metallic" aria-hidden="true" data-id="element-178" data-mp="3sohgfvaty1ei" />
            Sin permanencia forzosa. Cancela tu membresía cuando quieras.
          </p>
        </div>
      </section>
    </>;
}